import * as React from 'react';
import { Component, ReactNode } from 'react';
import InputComponent from './Input.component';

export interface InputProps {
  value?: string | File;
  label: string;
  placeholder?: string;
  type: string;
  required?: boolean;
  autocomplete?: boolean;
  iconName?: string;
  readOnly?: boolean;
  disabled?: boolean;
  maxLength?: number;
  onBlur?(): void;
  onChange(value: string | File): void;
}

interface InputState {
  value: string | File;
}

export default class InputContainer extends Component<InputProps, InputState> {

  private readonly id: string;

  constructor(props: InputProps) {
    super(props);
    this.state = {
      value: props.value || '',
    };

    this.id = 'input_' + props.label + props.type + Math.random().toString(36).substring(2);

    this.props.onChange(this.state.value);

    this.updateInput = this.updateInput.bind(this);

  }

  public componentWillReceiveProps(nextProps: InputProps): void {
    this.setState({value: nextProps.value || ''});
  }

  public render(): ReactNode {
    return (
        <InputComponent
            id={this.id}
            onChange={this.updateInput}
            onBlur={this.props.onBlur}
            required={this.props.required ? this.props.required : false}
            label={this.props.label || 'Text'}
            value={this.state.value}
            type={this.props.type || 'text'}
            placeholder={this.props.placeholder}
            iconName={this.props.iconName}
            autocomplete={this.props.autocomplete !== false}
            disabled={!!this.props.disabled}
            maxLength={this.props.maxLength}
        />
    );
  }

  private updateInput(newInput: string | File): void {
    if (!this.props.readOnly) {
      this.setState({value: newInput});
      this.props.onChange(newInput);
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/input/Input.container.tsx